import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, Button } from "react-bootstrap";

import * as actions from "../../../../../redux/tasks/actions";
import { getActiveProject } from "../../../../../redux/projects";
import { createTask } from "../../../../../redux/tasks";

import type TaskCollection from "../../models/TaskCollection";
import type Task from "../../models/Task";
import type User from "../../models/User";
import type Project from "../../models/Project";

import TaskForm from "../../../../../components/forms/task-form/TaskForm";

type Props = {
  user: ?User,
  onModalClose: () => void,
  project: Project,
};

type StateProps = {
  activeProject: ?Project,
  isCreatingEvent: boolean,
  isUpdatingEvent: boolean,
  activeEvent: ?TimelineEvent,
};

type State = {
  category: ?string,
};

class TaskModal extends Component {
  props: Props;
  state: State = {
    category: null,
  };
  createTaskPromise: ?Promise<void>;

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    return (
      <div>
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>New Task Category</Modal.Title>
          </Modal.Header>
          <TaskForm
            createTask={this.props.createTask}
            onDidCreateTask={this.props.onModalClose}
            user={this.props.user}
            onModalClose={this.props.onModalClose}
            projectId={this.props.activeProject.id}
          />
        </Modal.Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    activeProject: getActiveProject(state),
  };
};

export default connect(mapStateToProps, actions)(TaskModal);



// WEBPACK FOOTER //
// ./src/views/user/components/modals/task-modal/TaskModal.js